import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Schützt Routen vor nicht-authentifizierten Zugriffen.
 * Wartet auf initializeAuth() bevor isAuthenticated() geprüft wird —
 * verhindert Redirect zu /login während des App-Starts (Reload-Problem).
 *
 * Zwangs-Passwort-Wechsel (Phase 2): Wenn mustChangePassword gesetzt ist,
 * wird der User auf /passwort-aendern umgeleitet bis der Wechsel erfolgt.
 *
 * Pflicht-Passkey (Break-Glass, Task 10): Wenn passkeyRegistrationRequired=true,
 * wird der User auf /passkey-einrichten umgeleitet. Das Flag wird vom Backend
 * in /auth/me live berechnet (break_glass && passkeyCount==0) und ist false
 * sobald ein Passkey registriert ist — der Redirect endet damit automatisch.
 * WICHTIG: Nicht auf breakGlass prüfen! breakGlass ist PERMANENT true und würde
 * zu einem Dauer-Lockout führen (Endlos-Redirect nach Passkey-Registrierung).
 */
export const authGuard: CanActivateFn = async (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.initialized;

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Zwangs-Passwort-Wechsel: Wenn mustChangePassword gesetzt und Ziel nicht
  // bereits /passwort-aendern → umleiten, bis Wechsel abgeschlossen.
  if (authService.currentUser()?.mustChangePassword === true) {
    if (!state.url.startsWith('/passwort-aendern')) {
      return router.parseUrl('/passwort-aendern');
    }
  }

  // Pflicht-Passkey für Break-Glass-Konten: Redirect NUR solange
  // passkeyRegistrationRequired=true (= break_glass && passkeyCount==0).
  // Nach Passkey-Registrierung liefert /auth/me false → kein Redirect mehr.
  if (authService.currentUser()?.passkeyRegistrationRequired === true) {
    if (!state.url.startsWith('/passkey-einrichten')) {
      return router.parseUrl('/passkey-einrichten');
    }
  }

  return true;
};
